import type { ResponseAPI } from "@shapr3d/frontend-lib";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { downloadInfoURL } from "../config";
import { UMSrequestClient } from "../stores/requestClient";

export interface DownloadInfoResponseData {
  latest_version: string;
  update_url: string;
}

export default function useDownloadUrl(): UseQueryResult<DownloadInfoResponseData> {
  return useQuery({
    queryKey: ["downloadUrl"],
    queryFn: ({ signal }) =>
      UMSrequestClient.publicRequest({
        method: "GET",
        url: downloadInfoURL,
        abortSignal: signal,
      })
        .then((res: ResponseAPI) => {
          return res.json<DownloadInfoResponseData>();
        })
        .catch((error) => {
          console.error(error);
          throw error;
        }),
    staleTime: Infinity,
  });
}
